import { get, post } from './';

export const getPricingSummary = ({ resourceType, resourceId }) => {
  if (!resourceType || !resourceId) {
    return Promise.resolve(null);
  }

  return get(
    `api/v1/pricing-summaries/${resourceType.toLowerCase()}/${resourceId}`,
  );
};

export const savePricingSummary = data => {
  if (!data) {
    return Promise.resolve(null);
  }

  return post(`api/v1/pricing-summaries`, data);
};
